import { DTODesignSystemContactsResponse } from "../../dto";
import { RequestExecutor } from "../../transport/request-executor";

export class DesignSystemContactsEndpoint {
  constructor(private readonly requestExecutor: RequestExecutor) {}

  list(dsId: string) {
    return this.requestExecutor.json(`/design-systems/${dsId}/contacts`, DTODesignSystemContactsResponse, {
      method: "GET",
    });
  }
}
